import React from 'react';
import "./Practicals.css";

const Practicals = () => {

    return (
      <>
        <h2>Practicals</h2> <br />

        <div className="practicals">
            <a href="/studentsdashboard/practicals/nutrition">Test For Nutrition</a>
            {/* <a href="#">Grade 8 Term 2</a> */}
        </div>
        </>
    )
}

export default Practicals;